var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeOff({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.47937 0.849235C9.78372 0.605756 10.2162 0.605756 10.5205 0.849235L18.8539 7.5159C19.2132 7.80341 19.2715 8.32782 18.984 8.68721C18.6965 9.04659 18.1721 9.10486 17.8127 8.81735L17.0833 8.23381V16.5C17.0833 16.9602 16.7102 17.3333 16.2499 17.3333H3.74995C3.28971 17.3333 2.91662 16.9602 2.91662 16.5V8.23381L2.1872 8.81735C1.82781 9.10486 1.3034 9.04659 1.01589 8.68721C0.728384 8.32782 0.786652 7.80341 1.14604 7.5159L9.47937 0.849235ZM7.91658 10.25C7.45635 10.25 7.08325 10.6231 7.08325 11.0833V15.6666H12.9166V11.0833C12.9166 10.6231 12.5435 10.25 12.0833 10.25H7.91658Z",
    fill: "#88ABB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeOff);
export default __webpack_public_path__ + "static/media/home-off.b5ca41ebec7fa183176314cb158c739c.svg";
export { ForwardRef as ReactComponent };